export enum RequestStatusStage {
	FollowUpUnderStudy = 1,
	ReturnedForStudyCompletion = 2,
	AwaitingDataOrDocuments = 3,
	PendingSupervisorApproval = 4,
	ReturnedToSupervisor = 5,
	PendingDirectorApproval = 6,
	ReturnedToDirector = 7,
	RaisedToMinister = 8,
	InvestigationReportInPreparation = 9,
	ReturnedForInvestigationCompletion = 10,
	ProsecutionStatementInPreparation = 11,
	ReturnedToProsecutor = 12,
	AwaitingPartiesResponse = 14,
	LegalStudyInPreparation = 15,
	UnderReviewerReview = 16,
	AwaitingSessionScheduling = 17,
	AwaitingMinutesApproval = 18,
	DecisionDrafting = 19,
	FirstMemberNotes = 20,
	SecondMemberNotes = 21,
	PendingCommitteeChairApproval = 22,
	PreliminaryDecisionIssued = 23,
	FinalDecisionIssued = 24,
	Saved = 25,
	ReferredToPublicProsecution = 27,
	ReturnedToSbaOversight = 28,
	InvestigationAwaitingCompletion = 56,
	InvestigationPendingSupervisorApproval = 57,
	InvestigationReturnedToSupervisor = 58,
	InvestigationPendingDirectorApproval = 59,
	InvestigationReturnedToDirector = 74,
}
